import React, { useCallback, useEffect, useState } from 'react';
import { TabPanel, Item } from 'devextreme-react/tab-panel';
import './ResultDetails.scss';
import {
    Column,
    DataGrid,
    Editing
} from 'devextreme-react/data-grid';
import { checkPermission } from '../../../permissions.js';
import { EditCellTimeComponent, TimeBoxBold } from '../../utils/time-box/TimeBox.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { getApiToken } from '../../../utils/authUtils.js';
import { PerformanceCellOnlyIncrease } from '../../utils/performance-cell/PerformanceCell.js';
import { useMsal } from "@azure/msal-react";
export const ResultDetails = (props) => {
      const { instance, accounts } = useMsal();
    const [resultRankStore, setresultRankStore] = useState(null);
    const [resultSplitsStore, setresultSplitsStore] = useState(null);
    useEffect(() => {
        if (props.data.key) {
            getApiToken(instance, accounts).then((token) => {
      
                setresultRankStore({
                    store: createStore({
                        key: 'resultRankingId',
                        loadUrl: `${process.env.REACT_APP_serverEndpoint}/Rank/Ranks`,
                        insertUrl: `${process.env.REACT_APP_serverEndpoint}/Rank/InsertSplit`,
                        updateUrl: `${process.env.REACT_APP_serverEndpoint}/Rank/UpdateSplit`,
                        deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Rank/DeleteSplit`,
                        onBeforeSend: (method, ajaxOptions) => {
                            ajaxOptions.headers = {
                                'Authorization': "Bearer " + token
                            };
                        },
                    }),
                    filter: ['resultId', '=', props.data.data.resultId]
                });
                setresultSplitsStore({
                    store: createStore({
                        key: 'splitId',
                        loadUrl: `${process.env.REACT_APP_serverEndpoint}/Split/SplitsView`,
                        insertUrl: `${process.env.REACT_APP_serverEndpoint}/Split/InsertSplit`,
                        updateUrl: `${process.env.REACT_APP_serverEndpoint}/Split/UpdateSplit`,
                        deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Split/DeleteSplit`,
                        onBeforeSend: (method, ajaxOptions) => {
                            ajaxOptions.headers = {
                                'Authorization': "Bearer " + token
                            };
                        },
                    }),
                    filter: ['resultId', '=', props.data.data.resultId]
                });
            })
        }
    }, [props.data.key]);


    return (
        <div className='paneldetails'>
            <div className='left'>
                <DataGrid dataSource={resultSplitsStore} showBorders={true} remoteOperations={true}>
                    <Editing allowUpdating={checkPermission("result.edit")} allowAdding={false} allowDeleting={checkPermission("result.edit")} />
                    <Column dataField="distance" caption='Distanz' dataType='number'/>
                    <Column dataField="swimtime" caption='Zeit' dataType='number' cellRender={TimeBoxBold} editCellComponent={EditCellTimeComponent} hidingPriority={4} />
                    <Column dataField="roundtime" caption='Rundenzeit' dataType='number' cellRender={TimeBoxBold} editCellComponent={EditCellTimeComponent} allowEditing={false} hidingPriority={3} />
                    <Column
                        dataField='performance'
                        caption='Perfomance'
                        cellRender={PerformanceCellOnlyIncrease}
                        hidingPriority={2}
                        dataType='number'
                        
                    />
                    <Column dataField="rudolphPoints" caption='Rudolph-Punkte' dataType='number' allowEditing={false} hidingPriority={1}  />
                    <Column dataField="waPoints" caption='WA-Punkte' dataType='number' allowEditing={false} hidingPriority={0}  />
                </DataGrid>
            </div>

            <div className='right'>
                <div className='dx-card details-card'>
                    <DataGrid dataSource={resultRankStore} showBorders={true} remoteOperations={true}>
                        <Editing allowUpdating={checkPermission("result.edit")} allowAdding={false} allowDeleting={checkPermission("result.edit")} />
                        <Column dataField="rank" caption='Platzierung' calculateDisplayValue={function (e){ return (e.rank + " von " + e.totalRank)}} />
                        <Column dataField="description" caption='Beschreibung '  />

                    </DataGrid>
                </div>
            </div>
        </div>

    );
};

